import { Stat } from "../BackfillPanel";

export default function SummaryStats({ tipo, stats }) {
  const grand = stats.grand_total || 0;
  const com = stats.com_resumo || 0;
  const remaining = grand - com;
  const pct = Math.round((com / Math.max(1, grand)) * 100);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      <Stat label={`${tipo === "AU" ? "Áudios" : "Vídeos"} totais`} value={grand} />
      <Stat label="Com resumo" value={com} tone="ok" />
      <Stat label="Por processar" value={remaining} tone="warn" />
      <Stat label="Progresso" value={`${pct}%`} />
    </div>
  );
}
